module.exports = __webpack_public_path__ + "static/media/male_left.707d7037.jpg";